import { Typography as Text } from '@material-ui/core';

import { RiStopCircleLine } from '@remixicon/react';

import styles from './UserInterruptMessage.module.css';

export const UserInterruptMessage = () => (
  <div className={styles.root}>
    <RiStopCircleLine size={14} className={styles.icon} />
    <Text variant="body2" color="textSecondary">
      Response interrupted by the user
    </Text>
  </div>
);
